
export default function getElementIndex(elements, element) {
  return Array.prototype.indexOf.call(elements, element);
}
